/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Popup } from 'semantic-ui-react';
import { colors, nbColors } from 'utils/colors';
import { ComparePortfolio, Analytics } from 'actions';
import { withRouter } from 'react-router-dom';
import { Loading, Button } from 'components';
import { isNB } from 'utils/helpers';

import ExistingPortfolioSelection from './ExistingPortfolioSelection';
import WhatIfCustomization from './WhatIfCustomization';

import Intro from './Intro';
import Result from './Result';

class Compare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 'Intro',
    };
  }

  componentDidMount() {
    const { comparePortfolioState } = this.props;
    if (comparePortfolioState.compareResult) {
      this.setState({ view: 'Result' });
    }
  }

  setView = (name) =>
    this.setState({
      view: name,
    });

  handleReset = () => {
    const { dispatch, history } = this.props;
    const portfolioRegex = /^\/portfolio\/.*$/;
    dispatch(ComparePortfolio.clearComparison());
    if (!portfolioRegex.test(history.location.pathname)) {
      dispatch(Analytics.clearAnalytics());
    }
    this.setView('Intro');
  };

  renderView = () => {
    const { dispatch, french } = this.props;
    const { view } = this.state;
    switch (view) {
      case 'Intro':
        return <Intro setView={this.setView} dispatch={dispatch} />;
      case 'ExistingPortfolioSelection':
        return <ExistingPortfolioSelection setView={this.setView} />;
      case 'WhatIfCustomization':
        return <WhatIfCustomization setView={this.setView} />;
      case 'Result':
        return <Result setView={this.setView} />;
      default:
        return <Loading french={french} />;
    }
  };

  render() {
    const { french, partnerName } = this.props;
    const { view } = this.state;
    const buttonColor = isNB(partnerName) ? nbColors.blue : colors.blue;

    return (
      <CompareContent>
        {view !== 'Intro' ? (
          <Popup
            position="left center"
            trigger={
              <Button
                className="left reset button"
                color={buttonColor}
                icon="refresh"
                onClick={this.handleReset}
              >
                {french ? 'Recommencer' : 'Start Over'}
              </Button>
            }
            content={french ? 'Effacer et redémarrer' : 'Clear & Restart'}
          />
        ) : null}

        {this.renderView()}
      </CompareContent>
    );
  }
}

Compare.propTypes = {
  dispatch: PropTypes.func,
  history: PropTypes.object,
  match: PropTypes.object.isRequired,
  comparePortfolioState: PropTypes.object.isRequired,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
};

Compare.defaultProps = {
  dispatch: () => null,
  history: {},
  french: false,
  partnerName: '',
};

export default withRouter(
  connect((state) => ({
    comparePortfolioState: state.ComparePortfolio,
    french: state.Storage.language === 'fr',
    partnerName: state.Storage['partner-name'],
  }))(Compare)
);

const CompareContent = styled.div`
  position: relative;
  text-align: ${(props) => (props.centered ? 'center' : 'left')};
  min-height: 85vh;
  padding-top: 4rem;

  button.reset {
    position: absolute;
    top: 2rem;
    right: 2rem;
    z-index: 1;
  }
`;
